<tr class="ngx-table__header" *ngIf="config.headerEnabled">
  <th *ngIf="config.checkboxes || config.radio">
    <ng-container
      *ngIf="selectAllTemplate && config.checkboxes"
      [ngTemplateOutlet]="selectAllTemplate"
      [ngTemplateOutletContext]="{ $implicit: onSelectAllBinded }"
    >
    </ng-container>

    <nb-checkbox
      type="checkbox"
      id="selectAllCheckboxes"
      [checked]="isAllSelected"
      (checkedChange)="onSelectAll()"
    />
  </th>
  <ng-container *ngFor="let column of columns; let colIndex = index">
    <th
      [attr.data-key]="column.key"
      class="ngx-table__header-cell"
      [class.pinned-left]="column.pinned"
      [ngClass]="column.cssClass && column.cssClass.includeHeader ? column.cssClass.name : ''"
      [style.left]="styleService.pinnedWidth(column.pinned, colIndex)"
      #th
      [style.width]="getColumnWidth(column)"
      (mousedown)="onMouseDown($event, th)"
      (mouseup)="onMouseUp($event)"
      (mousemove)="onMouseMove($event)"
    >
      <div
        (click)="orderBy(column)"
        style="display: inline"
        [class.pointer]="isOrderEnabled(column)"
      >
        <div class="ngx-table__header-title">
          {{ column.title }}<span>&nbsp;</span>
          <em class="ngx-icon ngx-icon-pin" *ngIf="column.pinned"></em>
          <div [style.display]="config.orderEnabled ? 'inline' : 'none'">
            <em
              *ngIf="sortKey === column.key && sortState.get(sortKey) === 'asc'"
              class="ngx-icon ngx-icon-arrow-up"
            >
            </em>
            <em
              *ngIf="sortKey === column.key && sortState.get(sortKey) === 'desc'"
              class="ngx-icon ngx-icon-arrow-down"
            >
            </em>
          </div>
        </div>
      </div>
      <div class="ngx-dropdown" *ngIf="!!column.headerActionTemplate" #headerDropdown>
        <a class="ngx-btn ngx-btn-link" (click)="showHeaderActionTemplateMenu(column)">
          <span class="ngx-icon ngx-icon-more"></span>
        </a>
        <div
          class="ngx-menu ngx-table__table-menu"
          *ngIf="column.key === openedHeaderActionTemplate"
        >
          <ng-container [ngTemplateOutlet]="column.headerActionTemplate"></ng-container>
        </div>
      </div>
      <div class="ngx-table__column-resizer" *ngIf="config.resizeColumn" [attr.data-index]="colIndex" (dblclick)="onDblClickResizer($event)"></div>
    </th>
  </ng-container>
  <th
    *ngIf="
      config.additionalActions ||
      config.detailsTemplate ||
      config.collapseAllRows ||
      config.groupRows
    "
    class="ngx-table__header-cell-additional-actions"
  >
    <div class="ngx-dropdown" #additionalActionMenu *ngIf="config.additionalActions">
      <a class="ngx-btn ngx-btn-link" (click)="showMenu()">
        <tui-icon icon="settings-2"/>
      </a>
      <ul class="ngx-menu ngx-table__table-menu" *ngIf="menuActive">
        <ng-container
          *ngIf="additionalActionsTemplate"
          [ngTemplateOutlet]="additionalActionsTemplate"
        >
        </ng-container>
      </ul>
    </div>
  </th>
</tr>
<tr
  [style.display]="config.searchEnabled && !filtersTemplate ? 'table-row' : 'none'"
  class="ngx-table__search-header"
>
  <th *ngIf="config.checkboxes || config.radio"></th>
  <ng-container *ngFor="let column of columns; let colIndex = index">
    <th
      [ngClass]="column.cssClass && column.cssClass.includeHeader ? column.cssClass.name : ''"
      [class.pinned-left]="column.pinned"
      [style.left]="styleService.pinnedWidth(column.pinned, colIndex)"
    >

      @if (getColumnDefinition(column)) {
        @if (filterTemplate) {
          <ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: column, onSearch: onSearch.bind(this) }"/>
        } @else {
          <table-header (update)="onSearch($event)" [column]="column"/>
        }
      }
    </th>
  </ng-container>
  <th *ngIf="config.additionalActions || config.detailsTemplate"></th>
</tr>

<ng-container *ngIf="filtersTemplate">
  <tr>
    <ng-container [ngTemplateOutlet]="filtersTemplate"></ng-container>
  </tr>
</ng-container>
